import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getPowerSystemCookie } from "@/utils/auth";
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const judge = (to, next, hasCode) => {
  // 实时更新urlInfo(旧代码中有用到里边的数据)
  const powerToken = getPowerSystemCookie();
  if (powerToken) {
    const user = JSON.parse(powerToken);
    const newInfo = {
      userId: user.userInfo.userId,
      username: user.userInfo.username,
      systemCode: process.env.VUE_APP_SYSTEM_CODE,
      token: user.token,
    };
    sessionStorage.setItem("urlInfo", JSON.stringify(newInfo));
    if (store.getters.userId === "") {
      store
        .dispatch("GetUserInfo")
        .then(() => {
          // 拉取user_info
          store.dispatch("GenerateRoutes", {}).then(() => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            if (hasCode) {
              router.push({ path: "/" });
            } else {
              next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            }
          });
        })
        .catch((err) => {
          store.dispatch("LogOut").then(() => {
            Message.error(err);
            NProgress.done();
            window.close();
          });
        });
    } else {
      next();
    }
  } else {
    window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`;
  }
};
router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  console.log("to", to);

  if (window.location.href.indexOf("?code=") !== -1) {
    const NProgressInfo = JSON.parse(sessionStorage.getItem("urlInfo"));
    if (NProgressInfo) {
      judge(to, next, true);
    } else {
      store
        .dispatch("LoginByUsername")
        .then((res) => {
          router.push({ path: to.path }).catch((e) => {});
        })
        .catch((err) => {
          Message.error(err);
        });
    }
  } else if (to.fullPath.indexOf("fromDingding") > -1) {
    // 钉钉跳转免登
    const NProgressInfo = JSON.parse(sessionStorage.getItem("urlInfo"));
    const toNext = JSON.parse(JSON.stringify(to));
    toNext.fullPath = toNext.fullPath.replace("fromDingding", "");
    if (!NProgressInfo) {
      const domainStr =
        process.env.NODE_ENV === "production"
          ? ".suntekcorps.com"
          : ".sfccorps.com";
      const info = {
        token: to.query.token,
        userInfo: JSON.parse(to.query.userInfo),
      };
      Cookies.set("Power-Admin-Info", JSON.stringify(info), {
        expires: Number(to.query.expire),
        domain: domainStr,
      });
    }
    judge(toNext, next, false);
  } else if (getPowerSystemCookie()) {
    const NProgressInfo = JSON.parse(sessionStorage.getItem("urlInfo"));
    if (NProgressInfo) {
      judge(to, next);
    } else {
      // 取权限系统登陆时存的顶级域名cookie,组装成code格式
      const powerToken = getPowerSystemCookie();
      const user = JSON.parse(powerToken);
      const newInfo = {
        userId: user.userInfo.userId,
        username: user.userInfo.username,
        systemCode: process.env.VUE_APP_SYSTEM_CODE,
        token: user.token,
      };
      sessionStorage.setItem("urlInfo", JSON.stringify(newInfo));
      store
        .dispatch("GetUserInfo")
        .then(() => {
          // 拉取user_info
          store.dispatch("GenerateRoutes", {}).then(() => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          });
        })
        .catch((err) => {
          store.dispatch("LogOut").then(() => {
            Message.error(err);
            NProgress.done();
            window.close();
          });
        });
    }
  } else {
    window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`;
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
